<template>
        <footer class="reader-site-footer">
                <section class="legal" aria-label="Логотип">
                        <div class="brand"><span class="brand-logo" role="img" aria-label="АСТ-ПРЕСС ШКОЛА"></span></div>
                        <span v-if="route.name === 'about-ebook' || route.name === 'home'" class="legal-text project-label">О проекте</span>
                        <RouterLink v-else class="legal-text" :to="{ path: '/about-ebook', state: { bookOverviewPath: route.fullPath } }">О проекте</RouterLink>
                        <div class="year">© {{ copyrightYear }} ООО «АСТ-ПРЕСС ШКОЛА»</div>
                </section>
                <section class="support" aria-label="Поддержка и предложения">
                        <h2>Поддержка и предложения</h2>
                        <div class="dphon"><span class="icon phone" aria-hidden="true"></span>+7 (495) 150-44-00</div>
                        <div class="dmail"><a href="mailto:ebook.astpress@ast-press.ru"><span class="icon mail" aria-hidden="true"></span>ebook.astpress@ast-press.ru</a></div>
                </section>
                <section class="copyright" aria-label="Правовая информация">
                        <a class="legal-text" :href="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Политика обработки персональных данных</a>
                        <div class="cpright">Материалы электронной формы учебного пособия защищены авторским правом. Использование вне сервиса без разрешения правообладателя запрещено.</div>
                </section>
        </footer>
</template>

<script setup lang="ts">
        import "@/less/site-footer.less"
        import { RouterLink, useRoute } from "vue-router"
        import { useCopyrightYear } from "@/ts/api/server-time"

        const copyrightYear = useCopyrightYear()
        const route = useRoute()
        const privacyPolicyUrl = `${import.meta.env.BASE_URL}privacy-policy.pdf`
</script>
